(function () {
  'use strict';

  angular.module('ringbaPortal.services').factory('ringbaUserService', ringbaUserService);

  function ringbaUserService($http, ngAuthSettings) {
    'ngInject';

    const serviceBaseUri = ngAuthSettings.apiServiceBaseUri;

    const service = {
      getProfile: getProfile,
      updateProfile: updateProfile,
      changePassword: changePassword,
      getLoginHistory: getLoginHistory,
      revokeAllTokens: revokeAllTokens,
      geoLocateIps: geoLocateIps
    };

    return service;

    function getProfile() {
      const url = serviceBaseUri + 'profile';
      return $http.get(url);
    }

    function updateProfile(updateObject) {
      const url = serviceBaseUri + 'profile';
      return $http.patch(url, updateObject);
    }

    function changePassword(data) {
      const url = serviceBaseUri + 'profile/changepassword';
      return $http.post(url, data);
    }

    function getLoginHistory() {
      const url = serviceBaseUri + 'profile/MyLoginHistory';
      return $http.get(url);
    }
    function revokeAllTokens() {
      const url = serviceBaseUri + 'profile/RevokeAllTokens';
      return $http.get(url);
    }
    function geoLocateIps(ips) {
      const parameters = ips.join('&ip=');
      const url = 'https://display.ringba.com/locateip?ip=';
      const req = {
        method: 'GET',
        url: url + parameters,
        headers: {
          'Content-Type': 'application/json',
          'RinbaKey': 'FBE47E67-138B-4F44-BCF6-F7ACB2FF6F82'
        }
      };

      return $http(req);
    }
  }
})();
